module.exports = __webpack_public_path__ + "static/img/KE@3x.32924367.jpg";